module.exports = __webpack_public_path__ + "img/heard.1fa891dc.png";